import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Admin panelning "token" kalitidan mustaqil — ikkalasi bir brauzerda bir vaqtda
// ochiq bo'lishi mumkin (masalan test qilishda).
const TOKEN_KEY = 'client_token';

const token = localStorage.getItem(TOKEN_KEY);
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export const login = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/client/auth/login`, data);
    const { token, customer } = response.data;
    localStorage.setItem(TOKEN_KEY, token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return customer;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Xato yuz berdi');
  }
});

export const getMe = createAsyncThunk('auth/getMe', async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/client/auth/me`);
    return response.data.customer;
  } catch (error) {
    localStorage.removeItem(TOKEN_KEY);
    delete axios.defaults.headers.common['Authorization'];
    return rejectWithValue(error.response?.data?.message || 'Xato yuz berdi');
  }
});

// Standart "1111" parol bilan kirgan mijoz uchun majburiy bir martalik parol
// almashtirish (portalMustChangePassword=true bo'lganda ProtectedRoute shu
// ekranni bloklovchi holda ko'rsatadi). Muvaffaqiyatli bo'lsa server eski
// tokenni bekor qilib YANGI token qaytaradi — sessiya uzilmasin deb shu yerda
// darhol almashtiramiz.
export const changePassword = createAsyncThunk('auth/changePassword', async (newPassword, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/client/auth/change-password`, { newPassword });
    const { token } = response.data;
    localStorage.setItem(TOKEN_KEY, token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return true;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Xato yuz berdi');
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    customer: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    initialized: false,
  },
  reducers: {
    logout: (state) => {
      state.customer = null;
      state.isAuthenticated = false;
      state.error = null;
      state.initialized = true;
      localStorage.removeItem(TOKEN_KEY);
      delete axios.defaults.headers.common['Authorization'];
    },
    clearError: (state) => {
      state.error = null;
    },
    setInitialized: (state) => {
      state.initialized = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.customer = action.payload;
        state.isAuthenticated = true;
        state.initialized = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMe.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMe.fulfilled, (state, action) => {
        state.loading = false;
        state.customer = action.payload;
        state.isAuthenticated = true;
        state.initialized = true;
      })
      .addCase(getMe.rejected, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.initialized = true;
      })
      .addCase(changePassword.fulfilled, (state) => {
        if (state.customer) state.customer.mustChangePassword = false;
      });
  },
});

export const { logout, clearError, setInitialized } = authSlice.actions;
export default authSlice.reducer;
